import { Link } from "react-router-dom";
import { useAuth } from "@/context/AuthContext";
import { HardHat, Truck, FileSignature } from "lucide-react";

const TABS = [
  { key: "projects", to: "/projects", label: "Obras", icon: HardHat },
  { key: "machinery", to: "/machinery", label: "Maquinaria · todas", icon: Truck, roles: ["admin", "contador", "auxiliar", "residente", "supervisor"] },
  { key: "contracts", to: "/contracts", label: "Contratos · todos", icon: FileSignature, roles: ["admin", "contador", "auxiliar"] },
];

export const WorksNav = ({ active }) => {
  const { user } = useAuth();
  const role = user?.role;
  return (
    <div className="flex gap-1.5 flex-wrap" data-testid="works-nav">
      {TABS.filter((t) => !t.roles || role === "admin" || t.roles.includes(role)).map(({ key, to, label, icon: Icon }) => (
        <Link key={key} to={to} data-testid={`works-nav-${key}`}
          className="flex items-center gap-1.5 px-3 py-2 rounded-sm text-[11px] uppercase tracking-widest font-semibold transition-colors"
          style={active === key ? { background: "var(--magenta)", color: "white" } : { color: "var(--text-dim)", border: "1px solid var(--border-2)" }}>
          <Icon className="w-3.5 h-3.5" /> {label}
        </Link>
      ))}
    </div>
  );
};

export default WorksNav;
